import React, { useState } from 'react'

import { Card, CardHeader } from '@mui/material'
import { format, startOfMonth, subMonths } from 'date-fns'

import CustomerMetricsChart from './CustomerMetricsChart'
import CustomerMetricsDatePicker from './CustomerMetricsDatePicker'

const DATE_FORMAT = 'yyyy-MM-dd'

const CustomerMetricsCharts = () => {
  const start = startOfMonth(subMonths(new Date(), 2))
  const end = new Date()

  const [dates, setDates] = useState({ start: format(start, DATE_FORMAT), end: format(end, DATE_FORMAT) })

  const config = [
    { type: 'leads', label: 'Intent Companies', tooltip: 'Intent Companies Count' },
    { type: 'contacts', label: 'Contacts', tooltip: 'Contacts Usage' },
  ] as const

  return (
    <Card>
      <CardHeader action={<CustomerMetricsDatePicker dates={dates} setDates={setDates} />} />

      {config.map(({ type, label, tooltip }) => (
        <CustomerMetricsChart dates={dates} key={type} label={label} tooltip={tooltip} type={type} />
      ))}
    </Card>
  )
}

export default CustomerMetricsCharts
